<div class="tnc" cdkTrapFocus cdkTrapFocusAutoCapture="true">
    <div class="tnc-area">
        <p class="tnc-area__title text-2xl" id="modal-aria-label">
            {{ 'TERMS_AND_CONDITIONS' | translate }}
        </p>

        <iframe
            class="tnc__iframe tnc-middle"
            [src]="termsUrl | safeResourceUrl"
            title="{{ 'TERMS_CONDITIONS_TITLE' | translate }}">
        </iframe>

        <div class="tnc-bottom">
            <div class="tnc-bottom__btn">
                <button
                    class="btn btn--primary btn--maximal text-base"
                    (click)="agreeTerms(true)"
                    (keydown.enter)="agreeTerms(true)"
                    (keydown.space)="agreeTerms(true)"
                    tabindex="0">
                    <span class="gl-light:text-[var(--color-primary)]">{{ 'ACCEPT_TERMS' | translate }}</span>
                </button>
            </div>

            <div class="tnc-bottom__link">
                <a
                    class="link link--action link--emphasized text-base"
                    (click)="agreeTerms(false)"
                    (keydown.enter)="agreeTerms(false)"
                    (keydown.space)="agreeTerms(false)"
                    tabindex="0"
                    >{{ 'DECLINE' | translate }}</a
                >
            </div>
        </div>
    </div>
</div>
